import IntegrationCallStepResourceModel from '../../generated/types/model/resource/IntegrationCallStepResourceModel';

export default class IntegrationCallStepResourceViewModel extends IntegrationCallStepResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
